import QTable from 'quasar/src/components/table/QTable.js';

export const adminCampaignItemPaymentTableColumn = (): QTable['columns'] => [
  {
    name: 'item_type',
    field: 'item_type',
    label: 'نوع ایتم',
    align: 'center'
  },
  {
    name: 'item_id',
    field: 'item_id',
    label: 'شماره ایتم',
    align: 'center'
  },
  {
    name: 'amount',
    field: 'amount',
    label: 'مقدار',
    align: 'center'
  },
  {
    name: 'status',
    field: 'status',
    label: 'وضعیت',
    align: 'center'
  },
  {
    name: 'payment_type',
    field: 'payment_type',
    label: 'نوع تسویه',
    align: 'center'
  },
  {
    name: 'deposit_id',
    field: 'deposit_id',
    label: 'شماره واریزی',
    align: 'center'
  },
  {
    name: 'reservation_id',
    field: 'reservation_id',
    label: 'شماره رزرو',
    align: 'center'
  },
  {
    name: 'created_at',
    field: 'created_at',
    label: 'تاریخ ایجاد',
    align: 'center'
  },
  {
    name: 'actions',
    field: 'actions',
    label: 'عملیات',
    align: 'center'
  }
]